import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <nav aria-label="Breadcrumb" className="overflow-x-auto py-4 [scrollbar-width:thin]">
      <ol className="flex w-max min-w-full items-center space-x-2 text-sm">
        <li>
          <Link 
            to="/" 
            className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
            aria-label="Startseite"
          >
            <Home className="w-4 h-4" />
            <span className="sr-only">Startseite</span>
          </Link>
        </li>
        
        {items.map((item, index) => (
          <li key={index} className="flex shrink-0 items-center space-x-2">
            <ChevronRight className="w-4 h-4 text-muted-foreground" />
            {item.href && index < items.length - 1 ? (
              <Link 
                to={item.href} 
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground font-medium" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
